import script from "./restock.vue?vue&type=script&setup=true&lang=js"
export * from "./restock.vue?vue&type=script&setup=true&lang=js"

import "./restock.vue?vue&type=style&index=0&id=7cb83d7c&lang=css"

const __exports__ = script;

export default __exports__